import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const CoachingToDoSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        createCoachingToDo: builder.mutation({
            query: (arg: any) => ({
                url: constants.CREATE_COACHING_TODO,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['CoachingToDo','CoachingToDoView','ConversationAckReqCheck','coachingInsightHistory'],
        }),
        getCoachingToDoDetails: builder.query({
            query: (arg: any) => {
                const { employeenumber } = arg;
                return {
                    url: constants.GET_LATEST_TODOS,
                    params: {
                        employeenumber,
                    },
                };
            },
            providesTags: ['CoachingToDo'],
        }),
        coachingUserSearch: builder.query({
            query: (arg: any) => {
                const { searchEmployeeNumber, employeeNumber, title, userRole } = arg;
                return {
                    url: constants.COACHING_USER_SEARCH,
                    params: { employeeNumber, searchEmployeeNumber, title, userRole },
                };
            },
        }),
        conversationAckReqCheck: builder.query({
            query: (arg: any) => {
                const { employeeNumber, conversationId } = arg;
                return {
                    url: constants.CONVERSATION_ACK_REQ_CHECK,
                    params: { employeeNumber, conversationId },
                };
            },
            providesTags: ['ConversationAckReqCheck'],
        }),
    }),
});

export const { useGetCoachingToDoDetailsQuery, useCreateCoachingToDoMutation, useCoachingUserSearchQuery, useConversationAckReqCheckQuery } = CoachingToDoSlice;
